"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRouteBuilders = createRouteBuilders;
const segments_1 = require("../segments.js");
function createRouteBuilders({ i18n, pageSlugs }) {
    const { locales, defaultLocale, localePrefix } = i18n;
    function validateLocale(locale) {
        if (!locales.includes(locale)) {
            throw new Error(`Invalid locale: "${locale}"`);
        }
    }
    function getPageSlug(locale, pageType) {
        const localizedSlug = pageSlugs[locale]?.[pageType];
        if (localizedSlug) {
            return localizedSlug;
        }
        throw new Error(`Page type "${pageType}" not found for locale "${locale}".`);
    }
    function addLocalePrefix(path, locale) {
        if (localePrefix === "never") {
            return path;
        }
        if (localePrefix === "as-needed") {
            return locale === defaultLocale ? path : `/${locale}${path}`;
        }
        return `/${locale}${path}`;
    }
    const routes = {
        homepage: (locale) => {
            validateLocale(locale);
            return addLocalePrefix("", locale) || "/";
        },
        base: (segments, locale) => {
            validateLocale(locale);
            return addLocalePrefix(`/${(0, segments_1.createBaseSegment)(segments)}`, locale);
        },
        introduction: (segments, locale) => {
            validateLocale(locale);
            const path = `/${(0, segments_1.createBaseSegment)(segments)}/${getPageSlug(locale, "introduction")}`;
            return addLocalePrefix(path, locale);
        },
        guide: (segments, locale) => {
            validateLocale(locale);
            const path = `/${(0, segments_1.createBaseSegment)(segments)}/${getPageSlug(locale, "guide")}`;
            return addLocalePrefix(path, locale);
        },
        question: (segments, questionNumber, locale) => {
            validateLocale(locale);
            const path = `/${(0, segments_1.createBaseSegment)(segments)}/${getPageSlug(locale, "question")}/${questionNumber}`;
            return addLocalePrefix(path, locale);
        },
        review: (segments, locale) => {
            validateLocale(locale);
            const path = `/${(0, segments_1.createBaseSegment)(segments)}/${getPageSlug(locale, "review")}`;
            return addLocalePrefix(path, locale);
        },
        result: (segments, locale) => {
            validateLocale(locale);
            const path = `/${(0, segments_1.createBaseSegment)(segments)}/${getPageSlug(locale, "result")}`;
            return addLocalePrefix(path, locale);
        },
        publicResult: (segments, publicId, locale) => {
            validateLocale(locale);
            const path = `/${(0, segments_1.createBaseSegment)(segments)}/${getPageSlug(locale, "result")}/${publicId}`;
            return addLocalePrefix(path, locale);
        },
        comparison: (segments, locale) => {
            validateLocale(locale);
            const path = `/${(0, segments_1.createBaseSegment)(segments)}/${getPageSlug(locale, "comparison")}`;
            return addLocalePrefix(path, locale);
        },
    };
    return { routes };
}
